
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#92B8B8","d":"M31.356 16.34h5.181v18.023h-5.18zm-12.158.218h-5.181v18.024h5.181zm8.83.073h-5.181v18.024h5.18V16.631ZM0 44.175l48 .768v-4.446l-23.898.125L.204 42.827 0 44.176Z"}}),_c('path',{attrs:{"stroke":"#234652","d":"M7.798 14.308H3.852V12.86L24.322 4l20.47 8.86v1.448h-3.944m-33.05 0h33.05m-33.05 0v2.595h33.05v-2.595m-33.05 0v-.027m33.05.027v-.027M9.504 17.538h3.677l.588 18.06H9.033zm25.806 0h3.676l.589 18.06h-4.737zm-8.602 0h3.677l.588 18.06h-4.737zm-8.602 0h3.676l.59 18.06h-4.738z"}}),_c('path',{attrs:{"stroke":"#234652","d":"M42.522 35.542H6.04l-4.306 4.74v2.871h45.095v-2.871l-4.306-4.74Z"}})])
          )
        }
      }
    